import { get } from 'lodash';

export const getStatusSelectFilterOptions = () =>
  [
    {
      label: 'Booking Status',
      options: [
        {
          label: 'Unallocated',
          must: [
            {
              'masterStatusName.keyword': 'UNALLOCATED',
            },
          ],
        },
        {
          label: 'Pending',
          must: [
            {
              'masterStatusName.keyword': 'PENDING',
            },
          ],
          mustNot: [
            {
              'allocationStatus.keyword': 'review',
            },
            {
              'masterStatusName.keyword': 'CANCELLED',
            },
          ],
        },
        {
          label: 'Garage Declined',
          must: [
            {
              'allocationStatus.keyword': 'declined',
            },
          ],
        },
        {
          label: 'Time Changes',
          must: [
            {
              'allocationStatus.keyword': 'review',
            },
          ],
          mustNot: [
            {
              'masterStatusName.keyword': 'CANCELLED',
            },
          ],
        },
        {
          label: 'Allocated',
          must: [
            {
              'masterStatusName.keyword': 'ALLOCATED',
            },
          ],
        },
        {
          label: 'Awaiting Pickup',
          must: [
            {
              'masterStatusName.keyword': 'AWAITING_PICKUP',
            },
          ],
        },
        {
          label: 'Being Collected',
          must: [
            {
              'masterStatusName.keyword': 'BEING_COLLECTED',
            },
          ],
        },
        {
          label: 'At Garage',
          must: [
            {
              'garageStatus.keyword': 'WORK_STARTED',
            },
          ],
        },
        {
          label: 'Quoting Extra Work',
          must: [
            {
              'garageStatus.keyword': 'GARAGE_DRAFT',
            },
          ],
        },
        {
          label: 'To Review',
          must: [
            {
              'garageStatus.keyword': 'FIXTER_REVIEW',
            },
          ],
        },
        {
          label: 'Customer Reviewing',
          must: [
            {
              'garageStatus.keyword': 'CUSTOMER_REVIEW',
            },
          ],
        },
        {
          label: 'Customer Reviewed',
          must: [
            {
              'garageStatus.keyword': 'CUSTOMER_REVIEWED',
            },
          ],
        },
        {
          label: 'Work Complete',
          must: [
            {
              'masterStatusName.keyword': 'WORK_COMPLETE',
            },
          ],
        },
        {
          label: 'Work Complete - Delivered',
          must: [
            {
              'transportStatus.keyword': 'DELIVERED',
            },
          ],
          mustNot: [
            {
              'masterStatusName.keyword': 'CLOSED',
            },
          ],
        },
        {
          label: 'Work Complete - Paid',
          must: [
            {
              'masterStatusName.keyword': 'PAID',
            },
            {
              'paymentMethod.status.keyword': 'paid',
            },
          ],
        },
        {
          label: 'Unpaid',
          must: [
            {
              'masterStatusName.keyword': 'UNPAID',
            },
          ],
        },
        {
          label: 'Closed',
          must: [
            {
              'masterStatusName.keyword': 'CLOSED',
            },
          ],
        },
      ],
    },
    {
      label: 'Garage Initation Status',
      options: [
        {
          label: 'Expired',
          must: [
            {
              'garageInvitationStatus.keyword': 'expired',
            },
          ],
          mustNot: [
            {
              'garageInvitationStatus.keyword': 'accepted',
            },
            {
              'garageInvitationStatus.keyword': 'review',
            },
            {
              'garageInvitationStatus.keyword': 'cancelled',
            },
            {
              'garageInvitationStatus.keyword': 'declined',
            },
            {
              'masterStatusName.keyword': 'CANCELLED',
            },
          ],
        },
        {
          label: 'Declined',
          must: [
            {
              'allocationStatus.keyword': 'declined',
            },
          ],
        },
        {
          label: 'Accepted',
          must: [
            {
              'garageInvitationStatus.keyword': 'accepted',
            },
          ],
          mustNot: [
            {
              'masterStatusName.keyword': 'CANCELLED',
            },
          ],
        },
      ],
    },
    {
      label: 'Customer Payment Status',
      options: [
        {
          label: 'Awaiting Payment',
          must: [
            {
              'garageInvitationStatus.keyword': 'unpaid',
            },
          ],
          mustNot: [
            {
              'masterStatusName.keyword': 'CANCELLED',
            },
          ],
        },
        {
          label: 'Failed',
          must: [
            {
              'paymentMethod.status.keyword': 'failed',
            },
          ],
        },
        {
          label: 'Paid',
          must: [
            {
              'paymentMethod.status.keyword': 'paid',
            },
          ],
        },
      ],
    },
    {
      label: 'Garage Bill Status',
      options: [
        {
          label: 'Unsubmitted',
          must: [
            {
              'garagePaymentStatus.keyword': 'unsubmitted',
            },
          ],
        },
        {
          label: 'Submitted',
          must: [
            {
              'garagePaymentStatus.keyword': 'submitted',
            },
          ],
        },
        {
          label: 'On Hold',
          must: [
            {
              'garagePaymentStatus.keyword': 'on_hold',
            },
          ],
        },
        {
          label: 'Awaiting Approval',
          must: [
            {
              'garagePaymentStatus.keyword': 'awaiting_approval',
            },
          ],
        },
        {
          label: 'Awaiting Payment',
          must: [
            {
              'garagePaymentStatus.keyword': 'awaiting_payment',
            },
          ],
        },
        {
          label: 'Paid',
          must: [
            {
              'garagePaymentStatus.keyword': 'paid',
            },
          ],
        },
      ],
    },
  ].map((item, l1) => ({
    id: `[${l1}]`,
    ...item,
    options: item.options.map((option, l2) => ({
      id: `[${l1}].options[${l2}]`,
      ...option,
    })),
  }));

export const getSelectedStatusValue = (selectedId) => get(getStatusSelectFilterOptions(), selectedId);
